import TraceType from "./TraceType";

class Trace {
    public readonly id: string;
    public readonly userId: string;
    public readonly createdAt: number;
    public readonly description?: string;
    public readonly name: string;
    public readonly entityId: string;
    public readonly agencyId: string;
    public readonly type: TraceType;
    public readonly data: any;
    public readonly userName: string;

    constructor(
        id: string,
        userId: string,
        createdAt: number,
        description: string,
        name: string,
        entityId: string,
        agencyId: string,
        type: TraceType,
        data: any,
        userName: string,
    ) {
        this.id = id;
        this.userId = userId;
        this.createdAt = createdAt;
        this.description = description;
        this.name = name;
        this.entityId = entityId;
        this.agencyId = agencyId;
        this.type = type;
        this.data = data;
        this.userName = userName;
    }
}

export default Trace;